var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-scale-transition',[(_vm.showButton)?_c('v-btn',{staticClass:"ma-5",attrs:{"small":"","bottom":"","right":"","fixed":"","color":"amber darken-4","dark":"","fab":"","app":""},on:{"click":_vm.goToTop}},[_c('v-icon',[_vm._v("$vuetify.icons.angleUp")])],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }